import { createContext, useContext } from 'react'

export type MobileNavSide = 'left' | 'right'

export interface MobileNavContextValue {
  /** Open the narrow-viewport navigation sheet from the given edge. */
  openNav: (side?: MobileNavSide) => void
  /**
   * Tell the app layout that this page paints its own top line below the
   * `md` breakpoint, so the generic mobile top bar must stay hidden while the
   * page is mounted. Returns the release function.
   */
  claimTopBar: () => () => void
  /**
   * Tell the app layout that this surface owns the whole viewport, so the nav
   * rail, the mobile nav sheet and the top bar stay hidden while it is
   * mounted. Returns the release function.
   */
  claimChrome: () => () => void
}

// Default is a no-op so headers render fine outside AppLayout (tests, previews).
export const MobileNavContext = createContext<MobileNavContextValue>({
  openNav: () => {},
  claimTopBar: () => () => {},
  claimChrome: () => () => {},
})

export function useMobileNav(): MobileNavContextValue {
  return useContext(MobileNavContext)
}
